import i18n from "~/i18n";

const weekDays = [
  i18n.t("Monday"),
  i18n.t("Tuesday"),
  i18n.t("Wednesday"),
  i18n.t("Thursday"),
  i18n.t("Friday"),
  i18n.t("Saturday"),
  i18n.t("Sunday"),
];

export default weekDays;
